import { getSpaceOptionId } from '../components/SpaceSwitcher';

export const VENUE_WIDE_SPACE_PREFIX = '__venue_wide__';

/** Always at least one row for space selectors (synthetic when API returns none). */
export function resolveVenueSpacesForUi(venueSpaces, venueDetails, venueId) {
  const list = (Array.isArray(venueSpaces) ? venueSpaces : []).filter((s) => getSpaceOptionId(s));
  if (list.length > 0) return list;
  return [
    {
      id: `${VENUE_WIDE_SPACE_PREFIX}${venueId || 'default'}`,
      name: venueDetails?.name?.trim() || 'Main space',
      _synthetic: true
    }
  ];
}

export function isSyntheticVenueSpace(spaceOrId) {
  if (spaceOrId && typeof spaceOrId === 'object') {
    if (spaceOrId._synthetic) return true;
    return String(getSpaceOptionId(spaceOrId)).startsWith(VENUE_WIDE_SPACE_PREFIX);
  }
  return String(spaceOrId || '').startsWith(VENUE_WIDE_SPACE_PREFIX);
}

/** Real UUID for API calls, or null for venue-wide / synthetic selection. */
export function resolveApiSpaceId(spaceIdOrSpace) {
  const id =
    typeof spaceIdOrSpace === 'object'
      ? getSpaceOptionId(spaceIdOrSpace)
      : String(spaceIdOrSpace || '');
  if (!id || isSyntheticVenueSpace(id)) return null;
  return id;
}

export function rowMatchesSpace(row, spaceId, { includeVenueWide = true } = {}) {
  if (!row) return false;
  const apiSpace = resolveApiSpaceId(spaceId);
  const rowSpace = row?.space_id ?? row?.spaceId ?? null;
  if (!apiSpace) {
    return includeVenueWide ? rowSpace == null || rowSpace === '' : true;
  }
  if (rowSpace == null || rowSpace === '') return includeVenueWide;
  return String(rowSpace) === String(apiSpace);
}

export function filterRowsBySpace(rows, spaceId, options) {
  if (!Array.isArray(rows)) return [];
  return rows.filter((row) => rowMatchesSpace(row, spaceId, options));
}

export function packageMatchesSpace(pkg, spaceId, options) {
  const apiSpace = resolveApiSpaceId(spaceId);
  const linked = pkg?.space_ids ?? pkg?.spaceIds;
  if (Array.isArray(linked) && linked.length > 0) {
    if (!apiSpace) return options?.includeVenueWide !== false;
    return linked.some((id) => String(id) === String(apiSpace));
  }
  return rowMatchesSpace(pkg, spaceId, options);
}

export function filterPackagesBySpace(packages, spaceId, options) {
  if (!Array.isArray(packages)) return [];
  return packages.filter((pkg) => packageMatchesSpace(pkg, spaceId, options));
}

export function findSpaceById(spaces, spaceId) {
  const target = String(spaceId || '');
  if (!target) return null;
  return (spaces || []).find((s) => getSpaceOptionId(s) === target) || null;
}
